<template>
  <div class="footer">
    <p v-html="copyLinkMessage"></p>
    <p v-html="privacyMessage"></p>
    <p v-html="cookieMessage"></p>
  </div>
</template>
<script>
import DOMPurify from "dompurify";

export default {
  computed: {
    copyLinkMessage() {
      const link = ` | `
      return this.$t('FOOTER.MES1', { copyLink: link })
    },
    privacyMessage() {
      return this.translateWithLinks('FOOTER.MES2', {
        privacyLink: {
          href: 'https://www.mycwt.com/legal/global-privacy-policy-zh/',
          label: this.$t('FOOTER.PRIVACY_LINK'),
        },
      })
    },
    cookieMessage() {
      return this.translateWithLinks('FOOTER.MES3', {
        cookieLink: {
          href: 'https://www.mycwt.com/legal/cookies-policy/',
          label: this.$t('FOOTER.COOKIE_LINK'),
        },
        termsLink: {
          href: 'https://www.mycwt.com/legal/platform-terms-of-use/',
          label: this.$t('FOOTER.TERMS_LINK'),
        },
      })
    }
  },
  methods: {
    translateWithLinks(messageKey, links) {
      const tokens = {};
      const htmlLinks = {};

      Object.keys(links).forEach((key) => {
        const token = `__${key.toUpperCase()}__`;
        const link = links[key];
        tokens[key] = token;
        htmlLinks[token] = `<a href="${link.href}" target="_blank" rel="noopener noreferrer">${link.label}</a>`;
      });

      let message = this.$t(messageKey, tokens);
      Object.keys(htmlLinks).forEach((token) => {
        message = message.split(token).join(htmlLinks[token]);
      });

      return DOMPurify.sanitize(message, {
        ALLOWED_TAGS: ["a", "br", "span"],
        ALLOWED_ATTR: ["class", "href", "rel", "target"],
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
.footer {
  width: 100%;
  height: 11.1rem;
  background-color: $bg-color;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin: auto;

  p {
    font-size: 1.2rem;
  }
}
</style>